export default __webpack_public_path__ + "static/media/glosary.18c65fe9.svg";